import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Modal, ModalHeader, ModalBody, Input, InputGroup } from "reactstrap";
import {
  authKey_local_storage_key,
  getCompanyLogo,
  getJobExperiences,
  getKeywords,
  getSalaryAmount,
  redirect_url_key,
  showErrorMessage,
  titleCase,
} from "../common";
import AddToBookmarkJob from "./AddToBookmarkJob";
import ApplyJobModal from "./ApplyJobModal";
import NoLogo from "../../assets/images/featured-job/no-logo.png";
import { useEffect } from "react";
import { getJobIndustries } from "../../api/categories";
import { CustomSnackbar } from "../CustomSnackbar";
const SingleJobItem = ({ jobDetails }) => {
  //Apply for Job Model
  const [applyJobModal, setApplyJobModal] = useState(false);
  const [currJob, setCurrJob] = useState({});
  const [jobTypes, setJobTypes] = useState([]);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const { pathname, search } = useLocation();
  console.log(jobDetails);
  console.log("url_slug:", jobDetails?.url_slug);
  console.log("urlSlug:", jobDetails?.urlSlug);
  const authToken = localStorage.getItem(authKey_local_storage_key);
  const navigate = useNavigate();
  const getJobTypeName = (id) => {
    const type = jobTypes.find((item) => item.id === id);
    return type ? type.name : "Other";
  };
  const openApplyJobModal = (e, jobDetails) => {
    e.preventDefault();

    if (authToken) {
      setApplyJobModal(!applyJobModal);
      setCurrJob(jobDetails);
    } else {
      showErrorMessage("You need to sign in first.");

      localStorage.setItem(redirect_url_key, pathname + search);
      navigate("/signin");
    }
  };
  useEffect(() => {
    getJobIndustries().then((res) => {
      console.log("Job Types:", res.data.data);
      setJobTypes(res.data.data || []);
    });
  }, []);
  const customer = useSelector((state) => state.customer.profile);

  const companyDetails = jobDetails.company;
  const jobDetailsUrl = `/job/details/${jobDetails.id}/${jobDetails.urlSlug}`;

  const candidateReducer = useSelector((state) => state.candidate);
  const appliedJobs = candidateReducer.jobApplications;
  const city = jobDetails?.location?.name;
  const state = jobDetails?.location?.state;

  const locationText =
    city && state
      ? `${city}, ${state}`
      : city || state || "Location not specified";
  // Safe check: Pehle dekho ki appliedJobs ek Array hai ya nahi
  const appliedJobsArray = candidateReducer.jobApplications?.data || [];
  const isAppliedJob = Array.isArray(appliedJobsArray)
    ? appliedJobsArray.some((item) => {
      // Har tarike ki key check karein (Nayi aur Purani API dono ke liye)
      const jobIdInList = item?.job?.id || item?.jobId || item?.id;

      // Dono IDs ko Number mein convert karke match karein
      return jobIdInList && Number(jobIdInList) === Number(jobDetails?.id);
    })
    : false;
  const selectedJobType = jobTypes?.find(
    (item) => Number(item.id) === Number(jobDetails?.jobTypeCategoryId),
  );

  const jobShareUrl = `${window.location.origin}${jobDetailsUrl}`;
  const jobShareText = `Check out this job: ${jobDetails?.jobTitle || ""}`;

  const openShareModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShareModalOpen(true);
  };

  const closeShareModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShareModalOpen(false);
  };

  const shareOptions = [
    {
      key: "whatsapp",
      label: "WhatsApp",
      icon: "mdi mdi-whatsapp",
      color: "#25D366",
      action: () =>
        window.open(
          `https://wa.me/?text=${encodeURIComponent(`${jobShareText} ${jobShareUrl}`)}`,
          "_blank",
          "noopener,noreferrer",
        ),
    },
    {
      key: "facebook",
      label: "Facebook",
      icon: "mdi mdi-facebook",
      color: "#1877F2",
      action: () =>
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(jobShareUrl)}`,
          "_blank",
          "noopener,noreferrer",
        ),
    },
    {
      key: "instagram",
      label: "Instagram",
      icon: "mdi mdi-instagram",
      color: "#d7287f ",
      action: () =>
        window.open(
          `https://instagram.com/intent/instagram?text=${encodeURIComponent(jobShareText)}&url=${encodeURIComponent(jobShareUrl)}`,
          "_blank",
          "noopener,noreferrer",
        ),
    },
  
  ];

  const handleSocialShareClick = (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    action();
    setShareModalOpen(false);
    navigate("/jobs");
  };

  const handleCopyLink = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard
      .writeText(jobShareUrl)
      .then(() => CustomSnackbar.success("Job link copied!"))
      .catch(() => CustomSnackbar.error("Failed to copy link"));
    setShareModalOpen(false);
    navigate("/jobs");
  };

  // --- ADVANCED DEBUGGING CONSOLES ---
  console.log("---------- BOOKMARK DEBUG START ----------");
  console.log("1. Full JobDetails Object:", jobDetails);
  console.log("2. Job ID:", jobDetails?.id || jobDetails?.job?.id);

  // Check all possible paths where 'isBookmarked' could be hiding
  console.log("3. Status at Top Level:", jobDetails?.isBookmarked);
  console.log("4. Status inside Data key:", jobDetails?.data?.isBookmarked);
  console.log("5. Old Key Check:", jobDetails?.addclassNameBookmark);

  // Check if the keys exist at all
  console.log("6. Keys present in this object:", Object.keys(jobDetails || {}));
  console.log("---------- BOOKMARK DEBUG END ----------");
  const hasBookmark =
    jobDetails?.isBookmarked === true ||
    jobDetails?.addclassNameBookmark === true;
  return (
    <>
      <Link to={jobDetailsUrl}>
        <div
          className={
            hasBookmark
              ? "job-box bookmark-post card mt-4" // Yahan class apply hogi
              : "job-box card mt-4"
          }
        >
          <div className="p-4">
            <Row>
              <Col lg={2} className="text-lg-center">
                <img
                  src={getCompanyLogo(companyDetails?.logo)}
                  alt={companyDetails?.name}
                  className="img-fluid rounded-3 comp-logo"
                  // This function runs if the URL returns a 404 or fails to load
                  onError={(e) => {
                    e.target.onerror = null; // Prevents infinite loops if NoLogo also fails
                    e.target.src = NoLogo;
                  }}
                />
              </Col>

              <Col lg={10}>
                <div className="mt-3 mt-lg-0">
                  <h5 className="fs-17 mb-1 text-dark d-flex align-items-center flex-wrap gap-2">
                    {titleCase(jobDetails.jobTitle)}

                    <span className="text-muted fw-normal fs-15 d-inline-flex align-items-center gap-2">
                      {/* 💼 Experience Tag */}
                      <span className="badge bg-light text-secondary border px-2 py-1 rounded">
                        <i className="uil uil-briefcase-alt me-1 text-primary"></i>
                        {jobDetails?.minimumExperienceRequired || "0"} Exp
                      </span>

                      {/* 🕒 Time Ago Tag with Clock Icon */}
                      <span className="badge bg-light text-secondary border px-2 py-1 rounded">
                        <i className="uil uil-clock me-1 text-primary"></i>
                        {(() => {
                          if (!jobDetails?.createdAt) return "Recent";
                          const createdDate = new Date(jobDetails.createdAt);
                          const today = new Date();

                          createdDate.setHours(0, 0, 0, 0);
                          today.setHours(0, 0, 0, 0);

                          const diffTime = Math.abs(today - createdDate);
                          const diffDays = Math.floor(
                            diffTime / (1000 * 60 * 60 * 24),
                          );

                          if (diffDays === 0) return "Today";
                          if (diffDays === 1) return "1 day ago";
                          return `${diffDays} days ago`;
                        })()}
                      </span>
                    </span>
                  </h5>

                  <ul className="list-inline mb-0">
                    {companyDetails && companyDetails?.name && (
                      <li className="list-inline-item">
                        <p className="text-muted fs-14 mb-0">
                          <i className="mdi mdi-office-building text-primary"></i>{" "}
                          {companyDetails?.name} |
                        </p>
                      </li>
                    )}

                    <li className="list-inline-item">
                      <p className="text-muted fs-14 mb-0">
                        <i className="mdi mdi-tag-outline me-1 text-primary"></i>
                        {selectedJobType?.name || "Other"} |
                      </p>
                    </li>
                    <li className="list-inline-item">
                      <p className="text-muted fs-14 mb-0">
                        <i className="mdi mdi-map-marker text-primary"></i>{" "}
                        {locationText}
                      </p>
                    </li>

                    <li className="list-inline-item">
                      <p className="text-muted fs-14 mb-0">
                        <i className="mdi mdi-wallet text-primary"></i>
                        {jobDetails?.minimumSalaryPerMonth + "/month" ||
                          "Not Disclosed"}{" "}
                        {/* ✅ FIX */}
                      </p>
                    </li>
                    {/* 
                    <li className="list-inline-item">
                      <p className="text-muted fs-14 mb-0">
                        <i className="mdi mdi-wallet"></i>
                        {jobDetails?.salary
                          ? `${jobDetails.salary}/month`
                          : "Not Disclosed"}
                 
                      </p>
                    </li> */}
                  </ul>
                  {/* 
                  <div className='mt-2'>
                
                    <span
                      className={
                        jobDetails?.job_type?.toLowerCase() === "full time"
                          ? "badge bg-soft-success fs-13 mt-1 me-1"
                          : jobDetails?.job_type?.toLowerCase() === "part time"
                            ? "badge bg-soft-danger fs-13 mt-1 me-1"
                            : jobDetails?.job_type?.toLowerCase() === "freelancer"
                              ? "badge bg-soft-purple fs-13 mt-1 me-1"
                              : jobDetails?.job_type?.toLowerCase() === "internship"
                                ? "badge bg-soft-blue fs-13 mt-1 me-1"
                                : "badge bg-soft-secondary fs-13 mt-1 me-1"
                      }
                    >
                      {titleCase(jobDetails.job_type)}
                    </span>

                  
                    <span className='badge bg-soft-pink fs-13 mt-1 me-1'>
                      {jobDetails.jobTitle}
                    </span>

              
                    {jobDetails?.jobStatus?.toLowerCase() === "urgent" && (
                      <span className='badge bg-soft-warning fs-13 mt-1'>
                        Urgent
                      </span>
                    )}
                  </div> */}
                </div>
              </Col>
            </Row>

            {/* Bookmark button */}
            <AddToBookmarkJob
              size="sm"
              jobDetails={jobDetails}
              companyDetails={companyDetails}
            />
          </div>

          <div className="p-3 bg-light">
            <div className="row justify-content-between">
              <div className="col-md-8">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex align-items-center text-primary fw-medium me-2">
                    <i className="uil uil-chart-growing fs-16 me-1"></i>
                    <span className="fs-14">Trending Keywords:</span>
                  </div>

                  <div className="d-flex flex-wrap align-items-center m-n1">
                    {jobDetails?.searchKeywords &&
                      jobDetails.searchKeywords.trim() !== "" ? (
                      (() => {
                        const keywordsList = jobDetails.searchKeywords
                          .split(",")
                          .map((k) => k.trim())
                          .filter((k) => k.length > 0);

                        const maxVisible = 3; // Change this number to show more/fewer keywords by default
                        const visibleKeywords = keywordsList.slice(
                          0,
                          maxVisible,
                        );
                        const hiddenCount = keywordsList.length - maxVisible;

                        return (
                          <>
                            {visibleKeywords.map((keyword, index) => (
                              <div key={index} className="p-1">
                                <span className="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 fw-normal fs-14 cursor-pointer">
                                  #{keyword.toLowerCase()}
                                </span>
                              </div>
                            ))}

                            {/* Display +X More Badge if there are remaining keywords */}
                            {hiddenCount > 0 && (
                              <div className="p-1">
                                <span
                                  className="badge rounded-pill bg-secondary-subtle text-secondary border border-secondary-subtle px-2.5 py-2 fw-medium fs-14 cursor-pointer"
                                  title={keywordsList
                                    .slice(maxVisible)
                                    .join(", ")} // Shows hidden keywords on standard browser hover
                                >
                                  +{hiddenCount} more
                                </span>
                              </div>
                            )}
                          </>
                        );
                      })()
                    ) : (
                      <span className="text-muted fs-14 fst-italic p-1">
                        No keywords added
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {customer?.customer_type !== 1 ? (
                <div className="col-md-3">
                  <div className="text-md-end d-flex gap-2 justify-content-md-end">
                    {isAppliedJob ? (
                      <button
                        className="btn btn-outline-success btn-sm rounded-pill px-2 py-1 fw-semibold text-nowrap"
                        disabled
                      >
                        <i className="uil uil-check-circle me-1"></i>
                        Already Applied
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={(e) => openApplyJobModal(e, jobDetails)}
                        className="btn btn-primary btn-sm rounded-pill px-3 py-2 fw-semibold shadow-sm text-nowrap"
                      >
                        <i className="uil uil-arrow-right me-1"></i>
                        Apply Now
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={openShareModal}
                      className="btn btn-outline-primary btn-sm rounded-pill px-3 py-2 fw-semibold text-nowrap"
                    >
                      <i className="uil uil-share-alt me-1"></i>
                      Share
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Link>

      <ApplyJobModal
        currJob={currJob}
        setApplyJobModal={setApplyJobModal}
        applyJobModal={applyJobModal}
      />

      {/* 🎯 Share Job Modal */}
      <Modal isOpen={shareModalOpen} toggle={closeShareModal} centered>
        <ModalHeader toggle={closeShareModal}>Share this Job</ModalHeader>
        <ModalBody className="p-4">
          <div className="row g-3 text-center mb-4">
            {shareOptions.map((option) => (
              <div className="col-4" key={option.key}>
                <button
                  type="button"
                  onClick={(e) => handleSocialShareClick(e, option.action)}
                  className="btn w-100 border-0 bg-transparent"
                  style={{ padding: "12px 8px" }}
                >
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
                    style={{
                      width: "52px",
                      height: "52px",
                      backgroundColor: `${option.color}1A`,
                    }}
                  >
                    <i
                      className={option.icon}
                      style={{ fontSize: "24px", color: option.color }}
                    ></i>
                  </div>
                  <div className="fs-13 text-dark fw-medium">
                    {option.label}
                  </div>
                </button>
              </div>
            ))}
          </div>

          <div className="mt-2">
            <label className="form-label fs-13 text-muted mb-1">
              Or copy link
            </label>
            <InputGroup>
              <Input value={jobShareUrl} readOnly className="bg-light" />
              <button
                type="button"
                onClick={handleCopyLink}
                className="btn btn-primary"
              >
                <i className="mdi mdi-content-copy me-1"></i>
                Copy
              </button>
            </InputGroup>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SingleJobItem;